const normalizeObservedChatData = data => {
  if (!data || !Array.isArray(data.models)) return data
  const ts = data.ts
  for (const model of data.models) {
    if (!model || !Array.isArray(model.addedToTranscript)) continue
    for (const entry of model.addedToTranscript) {
      if (entry && !entry.ts) entry.ts = ts
    }
  }
  return data
}

module.exports = { normalizeObservedChatData }
